import Task from '@/components/nodes/task/task';
import idConfigSettings from '@/components/inspectors/idConfigSettings';
import emailIcon from '!!url-loader!@/assets/send-email.svg';
import rules from '@/mixins/ilios_functions.js'

window.ProcessMaker.EventBus.$on('modeler-init', ({ registerNode }) => {
  /* Add a custom node example */

  const implementation = 'processmaker-modeler-send-email';
  const nodeId = 'processmaker-modeler-send-email';

  const component = {
    extends: Task,
    watch: {
      'node.definition.name'(name) {
        switch (name) {
          default:
            this.$delete(this.markers.topRight, 'vocabulary');
            this.$delete(this.markers.topRight, 'clock');
        }
      },
    },
    mounted() {
      this.$set(this.markers.topRight, 'vocabulary', emailIcon);
    },
  };

  const nodeType = {
    id: nodeId,
    component,
    bpmnType: 'bpmn:ScriptTask',
    control: true,
    category: 'Other',
    icon: require('@/assets/toolpanel/iliosSendEmail.svg'),
    label: 'Enviar Email',
    rank: 49,
    definition(moddle) {
      return moddle.create('bpmn:ScriptTask', {
        name: 'Enviar Email',
        implementation,
        config: JSON.stringify({}),
        backId: null,
      });
    },
    diagram(moddle) {
      return moddle.create('bpmndi:BPMNShape', {
        bounds: moddle.create('dc:Bounds', {
          height: 76,
          width: 116,
        }),
      });
    },
    inspectorConfig: [
      {
        name: 'Send Tweet',
        items: [
          {
            component: 'FormText',
            config: {
              label: 'Send Tweet',
              fontSize: '2em',
            },
          },
          {
            component: 'FormInput',
            config: idConfigSettings,
          },
          {
            component: 'FormInput',
            config: {
              label: 'Name',
              helper: 'Name',
              name: 'name',
            },
          },
        ],
      },
    ],
    entryRules(sequenceFlow){
      let result = []
      let findError
      result.push(rules.oneEntryConector(sequenceFlow))
      findError = result.find(el => el.result === false)
      if (findError){
        return findError
      } else {
        return {result: true}
      }
    },
    exitRules(genericFlow){
      let result = []
      let findError
      result.push(rules.oneExitConector(genericFlow))
      result.push(rules.entryNotIsMultGateway(genericFlow))
      findError = result.find(el => el.result === false)
      if (findError){
        return findError
      } else {
        return {result: true}
      }
    },
  };

  registerNode(nodeType, definition => {
    if (definition.get('implementation') === implementation) {
      return nodeId;
    }
  });
});
